"use strict";

const resolveLeadCsrfTokenUrl = (formUrl, explicitUrl) => {
    if (explicitUrl) {
        return explicitUrl;
    }

    return String(formUrl || "").replace("Lead-GenerateCallMe", "Lead-CsrfToken");
};

const fetchLeadCsrfToken = (csrfTokenUrl) => {
    const deferred = $.Deferred();

    if (!csrfTokenUrl) {
        deferred.resolve(null);
        return deferred.promise();
    }

    $.ajax({
        url: csrfTokenUrl,
        type: "GET",
        data: { format: "json" },
        dataType: "json",
        cache: false
    }).done(function (response) {
        deferred.resolve(response && response.csrf && response.csrf.token ? response.csrf : null);
    }).fail(function () {
        deferred.resolve(null);
    });

    return deferred.promise();
};

const applyLeadCsrfToken = ($form, serializedData, csrf) => {
    if (!csrf || !csrf.tokenName || !csrf.token) {
        return serializedData;
    }

    const $csrfField = $form.find("input[name='" + csrf.tokenName + "']");

    if ($csrfField.length) {
        $csrfField.val(csrf.token);
    } else {
        $("<input>", {
            type: "hidden",
            name: csrf.tokenName,
            value: csrf.token
        }).appendTo($form);
    }

    const params = new URLSearchParams(serializedData);

    params.set(csrf.tokenName, csrf.token);

    return params.toString();
};

export {
    applyLeadCsrfToken,
    fetchLeadCsrfToken,
    resolveLeadCsrfTokenUrl
};
